import { CUSTOM_LAYOUT_PRESETS, listBundledCustomLayoutPresetIds, } from './registry';
import { createDebugLogger } from '../utils/debug';
const debug = createDebugLogger('customLayout');
/**
 * Applies bundled preset HTML/CSS when `customLayout.preset` or
 * `settings.custom_layout_preset` is set (e.g. `custom-1`).
 * Explicit non-empty `template` / `stylesheet` on `customLayout` override preset defaults.
 */
export function resolveBundledCustomLayout(customLayout, settings) {
    const presetRaw = customLayout?.preset?.trim() ||
        settings?.custom_layout_preset?.trim() ||
        '';
    const merged = { ...(customLayout ?? {}) };
    if (presetRaw) {
        const bundled = CUSTOM_LAYOUT_PRESETS[presetRaw.toLowerCase()];
        if (!bundled) {
            debug.warn(`Unknown custom layout preset "${presetRaw}". Known: ${listBundledCustomLayoutPresetIds().join(', ')}`);
        }
        else {
            if (!merged.template?.trim()) {
                merged.template = bundled.template;
            }
            if (!merged.stylesheet?.trim()) {
                merged.stylesheet = bundled.stylesheet;
            }
        }
    }
    const hasUsefulFields = merged.render ||
        merged.template?.trim() ||
        merged.templateSelector?.trim() ||
        merged.stylesheet?.trim();
    if (!hasUsefulFields) {
        return customLayout;
    }
    return merged;
}
